import * as PropTypes from 'prop-types'
import classNames from 'classnames'

import variablesStyles from '/styles/variables.css'
import flightLineVerticalStyles from './FlightLineVertical.css'

import { withViewport } from '/react/utils/withViewport'

import { defaultPathProps, defaultSvgProps } from './FlightLineAnimation'

const defaultPropTypes = {
  forwardRef: PropTypes.object,
  isLight: PropTypes.bool
}

const linePathPositions = {
  left: 250,
  middle: 720,
  right: 1190
}

@withViewport()

class FlightLineVertical extends React.PureComponent {
  static propTypes = {
    ...defaultPropTypes,
    position: PropTypes.oneOf(['left', 'middle', 'right']).isRequired
  }

  state = {
    isMounted: false,
  }

  componentDidMount () {
    this.setState({ isMounted: true })
  }

  render () {
    const {
      forwardRef, // TODO: delete prop
      isLight,
      position,
      viewportIsTabletOrSmaller
    } = this.props

    const {
      isMounted
    } = this.state

    if (!isMounted) return null

    const pathProps = {...defaultPathProps}
    const svgProps = {...defaultSvgProps}

    if (viewportIsTabletOrSmaller) {
      return (
        <div
          className={classNames(
            flightLineVerticalStyles.line,
            {
              [flightLineVerticalStyles.isLight]: isLight,
              [flightLineVerticalStyles.isLeft]: position === 'left' || position === 'right',
              [flightLineVerticalStyles.isMiddle]: position === 'middle'
            }
          )}
          ref={forwardRef}
        />
      )
    }

    if (isLight) pathProps.stroke = variablesStyles.colorWhite

    return (
      <svg
        className={flightLineVerticalStyles.svg}
        ref={forwardRef}
        viewBox='0 0 1440 206'
        {...svgProps}
      >
        <path {...pathProps} d={`M${linePathPositions[position]} 0v206`} />
      </svg>
    )
  }
}

export class FlightLineLeft extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <FlightLineVertical {...this.props} position='left' />
    )
  }
}

export class FlightLineMiddle extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <FlightLineVertical {...this.props} position='middle' />
    )
  }
}

export class FlightLineRight extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <FlightLineVertical {...this.props} position='right' />
    )
  }
}
